"use client";

import { cn } from "../../../lib/utils.ts";
import React, { useEffect, useState } from "react";
import { CardContainer, CardBody, CardItem } from "./3d-card.tsx";

export const InfiniteMovingCards = ({
  components,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
  className,
  onCardClick,
}) => {
  const containerRef = React.useRef(null);
  const scrollerRef = React.useRef(null);
  const [start, setStart] = useState(false);
  const [cards, setCards] = useState([...components]);

  useEffect(() => {
    duplicateCards();
  }, []);

  function duplicateCards() {
    if (components.length > 0) {
      setCards([...components, ...components]);
    }
    getDirection();
    getSpeed();
    setStart(true);
  }

  const getDirection = () => {
    if (containerRef.current) {
      containerRef.current.style.setProperty("--animation-direction", direction === "left" ? "forwards" : "reverse");
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      containerRef.current.style.setProperty("--animation-duration", speed === "fast" ? "20s" : speed === "normal" ? "40s" : "80s");
    }
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        "scroller relative z-20 max-w-7xl overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
        className
      )}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          "flex min-w-full shrink-0 gap-4 py-4 w-max flex-nowrap",
          start && "animate-scroll",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {cards.map((card, index) => (
          <div
            key={index}
            onClick={() => onCardClick(card.props.data)}
            className="cursor-pointer"
          >
            <CardContainer className="p-4 flex flex-col hover:bg-gray-950 rounded-xl">
              <CardBody>
                <div className="flex flex-col items-center"> 
                  <CardItem translateZ="100">
                    <img
                      src={card.props.data.src}
                      alt={card.props.data.title}
                      className="w-44 aspect-video rounded-lg object-cover object-top"
                    />
                  </CardItem>
                  <CardItem translateZ="75">
                    <h3 className="text-white font-semibold text-center text-base mt-2 w-full">
                      {card.props.data.title}
                    </h3>
                  </CardItem>
                  <CardItem translateZ="50">
                    <p className="text-gray-400 text-center text-sm">
                      {card.props.data.description}
                    </p>
                  </CardItem>
                </div>
              </CardBody>
            </CardContainer>
          </div>
        ))}
      </ul>
    </div>
  );
};
